import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/api";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function Login() {
  const [passcode, setPasscode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { passcode });
      setToken(res.data.token);
      toast.success("Authenticated as operator");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid passcode");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center p-4">
      <div className="w-full max-w-sm border border-slate-800 bg-[#111827] rounded-lg p-8 space-y-6" data-testid="login-card">
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <ShieldCheck size={18} className="text-sky-400" />
            <h1 className="font-heading text-2xl font-semibold tracking-tight text-slate-100">KNKT Outreach</h1>
          </div>
          <p className="text-sm text-slate-400">Single-operator access. Enter the operator passcode.</p>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <input
            type="password"
            value={passcode}
            onChange={(e) => setPasscode(e.target.value)}
            placeholder="Operator passcode"
            data-testid="login-passcode-input"
            className="w-full bg-slate-900/80 border border-slate-700 rounded-md px-3 py-2.5 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-sky-500 font-mono"
            autoFocus
          />
          <button
            type="submit"
            disabled={loading || !passcode}
            data-testid="login-submit-btn"
            className="w-full bg-sky-600 hover:bg-sky-500 disabled:opacity-40 text-white text-sm font-medium rounded-md px-3 py-2.5 transition-colors duration-150"
          >
            {loading ? "Verifying…" : "Enter Operating Surface"}
          </button>
        </form>
        <p className="font-mono text-[10px] uppercase tracking-widest text-slate-600">
          App presents · Agent thinks · Human decides
        </p>
      </div>
    </div>
  );
}
